import styled from '@emotion/styled';

const OverlayContainer: React.ElementType = styled.div({
  position: 'relative'
});
export default OverlayContainer;
